import { Component } from 'preact';
import type { ComponentChildren } from 'preact';
import { ErrorTile } from './ErrorTile.js';

interface Props {
  path?: string | undefined;
  children?: ComponentChildren;
}

interface State {
  error: Error | null;
}

/**
 * Contains a runtime crash to the widget that caused it.
 *
 * Config errors are caught by validation before render; this catches the other
 * half — a widget that throws while drawing. Either way one bad tile must never
 * blank the dashboard.
 */
export class WidgetBoundary extends Component<Props, State> {
  override state: State = { error: null };

  static override getDerivedStateFromError(error: Error): State {
    return { error };
  }

  override componentDidCatch(error: Error): void {
    console.error('[hud] widget crashed', this.props.path, error);
  }

  override render() {
    if (this.state.error) {
      return (
        <ErrorTile
          title="Widget crashed"
          path={this.props.path}
          message={this.state.error.message}
        />
      );
    }
    return this.props.children;
  }
}
